import { useEffect } from 'react';

export function useDebouncedResizeObserver(ref, callback, delay = 200) {
  useEffect(() => {
    if (!ref.current) return;

    let timeoutId;

    const handleResize = (entries) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        callback(entries[0].contentRect);
      }, delay);
    };

    const observer = new ResizeObserver(handleResize);
    observer.observe(ref.current);

    return () => {
      clearTimeout(timeoutId);
      observer.disconnect();
    };
  }, [ref, callback, delay]);
}
